import {
    CLEAR_OFFICER_PROFILE,
    FETCH_OFFICER_PERMISSIONS,
    GET_ALL_DEPARTMENTS,
    GET_ALL_OFFICERS_LIST,
    GET_ALL_PERMISSIONS,
    GET_ALL_ROLES,
    GET_ELIGIBLE_OFFICERS,
    GET_OFFICER_PROFILE,
    GET_OFFICER_PROFILE_ERROR,
    GET_OFFICER_PROFILE_LOADING,
    GET_OFFICERS,
    USER_ERROR,
    USER_LOADER,
} from "../actionType";

let initialState = {
    loading: false,
    error: null,
    officers: {},
    eligibleOfficers: {},
    officerList: {},
    permissions: [],
    officerPermissions: new Set(),
    roles: {},
    officerProfile: null,
    officerProfileLoading: false,
    officerProfileError: null,
    departments: [],
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case USER_LOADER:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case USER_ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_OFFICERS:
            return {
                ...state,
                loading: false,
                officers: { 
                    officers: [...payload.officers], 
                    branchReport: payload.branch_report, 
                    hoOfficers:  payload.ho_officers, 
                    pagination: payload.pagination 
                },
                error: null,
            };
        case GET_ELIGIBLE_OFFICERS:
            return {
                ...state,
                loading: false,
                eligibleOfficers: { 
                    officers: [...payload.officers], 
                    pagination: payload.pagination 
                },
                error: null,
            };
        case GET_ALL_OFFICERS_LIST:
            return {
                ...state,
                loading: false,
                officerList: { 
                    officers: [...payload.officers], 
                    pagination: payload.pagination 
                },
                error: null,
            };
        case GET_ALL_PERMISSIONS:
            return {
                ...state,
                loading: false,
                permissions: payload,
                error: null,
            };
        case GET_ALL_ROLES:
            return {
                ...state,
                loading: false,
                roles: { rolesList: payload.roles, pagination: payload.pagination},
                error: null,
            };
        case GET_ALL_DEPARTMENTS:
            return {
                ...state,
                loading: false,
                departments: payload,
                error: null,
            };
        // case FETCH_OFFICER_PERMISSIONS:
        //     return {
        //         ...state,
        //         loading: false,
        //         officerPermissions: payload,
        //         error: null,
        //     };
        case GET_OFFICER_PROFILE: {
            const permissions = new Set(payload?.permissions?.map(p => p.permission_code)) ?? new Set();

            return {
                ...state,
                officerProfileLoading: false,
                officerProfile: payload,
                officerPermissions: permissions,
                officerProfileError: null,
            };
        }
        case GET_OFFICER_PROFILE_LOADING: {
            return {
                ...state,
                officerProfileLoading: true,
                officerProfile: null,
                officerPermissions: new Set(),
                officerProfileError: null,
            };
        }
        case GET_OFFICER_PROFILE_ERROR: {
            return {
                ...state,
                officerProfileLoading: false,
                officerProfile: null,
                officerPermissions: new Set(),
                officerProfileError: payload,
            };
        }

        case CLEAR_OFFICER_PROFILE: {
            return {
                ...state,
                officerProfileLoading: false,
                officerProfile: null,
                officerPermissions: new Set(),
                officerProfileError: null,
            };
        }

        default:
            return state;
    }
};